namespace Ir.Components.Workbook.Settings.KPISettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        itemConfig: BaseItemConfig;

        //duplicate with KPIWidgetResultVM
        customTitle: KnockoutComputed<string>;

        titleTextSettings: any;
        targetTextSettings: any;
        trendAxisHeightOptions: any;
        iconSizeOptions: any;
        tabsOptions: any;
        trendAxisPopoverButtonOptions: any;
        trendAxisRemoveButtonOptions: any;
        trendAxisTextBoxOptions: any;
        fontStyleOptions: any;
        filterZerosOptions: any;
        useLastPeriodOptions: DevExpress.ui.dxSwitch.Properties;
        
        distanceOptions: any;
        tabDetailOrderOptions: any;
        //tabDetailButtonOptions: any;
        tabDetailOrderDirectionOptions: any;

        indicatorParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        targetParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        trendAxisParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        formattingRuleParams: Ir.Components.Workbook.Settings.Items.FormattingRuleSetting.IFormattingRuleSettingParams;
        comparisonFilterParams: Ir.Components.Workbook.Settings.Items.ComparisonFilterSetting.IComparisonFilterSettingParams;
        formatOptions: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingParams;
        decimalPlacesOptions: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;

        targetFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        titleFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        indicatorFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;

        fontStyleButtonGroupOptions: DevExpress.ui.dxButtonGroup.Properties;
        fontStyleTargetButtonGroupOptions: DevExpress.ui.dxButtonGroup.Properties;
        fontStyleTitleButtonGroupOptions: DevExpress.ui.dxButtonGroup.Properties;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;

        self.config = params.config as WorkbookConfig;
        self.activeTabOrWidget = params.activeTabOrWidget;
        self.activeTabItem = params.activeTabItem;
        let itemConfig = self.activeTabOrWidget().itemConfig() as KPIConfig;
        let kpiWidget = this.activeTabOrWidget().widget.getWidget<KPIWidget>() as KPIWidget;
        self.itemConfig = itemConfig;

        self.customTitle = ko.computed(function () { return itemConfig.titleText() /*|| self.indicatorMetricName()*/; }, self);

        self.titleTextSettings = {};
        self.targetTextSettings = {};
        setBaseTextConfig(self.titleTextSettings, itemConfig.titleTextConfig);
        setBaseTextConfig(self.targetTextSettings, itemConfig.targetTextConfig);

        self.trendAxisHeightOptions = {
            format: "#px",
            value: itemConfig.trendAxisHeight,
            step: 1,
            showSpinButtons: true,
            min: 10,
            max: 200,
            width: 80,
        };

        self.indicatorFontSizeOptions = {
            value: itemConfig.indicatorFontSize,
        };

        self.iconSizeOptions = {
            format: "0#px",
            value: itemConfig.iconSize,
            step: 1,
            showSpinButtons: true,
            min: 0,
            max: 200,
            width: 80,
        };

        self.comparisonFilterParams = {
            label: "Target Comparison Filter",
            manualText: "None",
            comparisonFilter: itemConfig.comparisonFilter,
            onValueChanged() {
                kpiWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            }
        }

        this.indicatorParams = {
            label: "Indicator",
            type: MappingPopoverTypeEnum.Metrics,
            id: itemConfig.indicatorMetric,
            onSelected(newValue: FieldNameInputModel, oldValue: FieldNameInputModel) {
                kpiWidget.saveSettingItemManually = true;

                if (!itemConfig.titleText() || itemConfig.titleText() === oldValue?.nodeName || itemConfig.titleText() === "Title")
                    itemConfig.titleText(newValue.nodeName);

                //If the indicator metric is the same of target because of the comparison filter, update the target metric too
                if (itemConfig.targetMetric() === itemConfig.indicatorMetric() && itemConfig.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual) {
                    itemConfig.targetMetric(newValue.metricId);
                }
                itemConfig.decimalPlaces(newValue.decimalPlaces);
                itemConfig.format(newValue.format);
                itemConfig.accountingStyle(newValue.accountingStyle);

                if (newValue.formattingRuleId > 0 && (!itemConfig.formattingRule() || itemConfig.formattingRule() === 0)) {
                    itemConfig.formattingRule(newValue.formattingRuleId);
                }

                kpiWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            },
            onClear(oldValue: FieldNameInputModel) {
                kpiWidget.saveSettingItemManually = true;

                if (itemConfig.titleText() === oldValue?.nodeName)
                    itemConfig.titleText(null);
                itemConfig.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);

                kpiWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            },
        };
        
        self.targetParams = {
            label: "Target",
            type: MappingPopoverTypeEnum.Metrics,
            id: itemConfig.targetMetric,
            onSelected(newValue: FieldNameInputModel, oldValue: FieldNameInputModel) {
                if (newValue.metricId !== itemConfig.indicatorMetric())
                    itemConfig.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);
            },
            onClear(oldValue: FieldNameInputModel) {
                itemConfig.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);
            }
        };

        self.trendAxisParams = {
            label: "Trend Axis",
            type: MappingPopoverTypeEnum.Date,
            id: itemConfig.trendAxisField,
            autoGrouping: itemConfig.trendAxisFieldAutoGrouping,
        };

        self.formattingRuleParams = {
            label: "Formatting Rule",
            id: itemConfig.formattingRule,
        }

        self.formatOptions = {
            value: itemConfig.format
        };

        self.fontStyleOptions = [
            {
                icon: 'bold',
                style: 'Bold',
                hint: 'Bold'
            },
            {
                icon: 'italic',
                style: 'Italic',
                hint: 'Italic'
            }
        ];

        self.filterZerosOptions = {
            value: itemConfig.filterZeros,
        };

        self.useLastPeriodOptions = {
            value: itemConfig.useLastPeriod as any,
            onValueChanged(e) {
                if (e.value && itemConfig.comparisonFilter) {
                    itemConfig.comparisonFilter.dateOption(ComparisonDateOptionEnum.Previous);
                }
            }
        };

        self.decimalPlacesOptions = {
            value: itemConfig.decimalPlaces
        };

        self.distanceOptions = {
            dataSource: ko.observableArray(getDistanceOptions(self)),
            displayExpr: "text",
            valueExpr: "value",
            width: 140,
            value: itemConfig.distanceType,
            elementAttr: { class: 'dx-textbox-right' },
        };

        self.tabDetailOrderOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.tabDetailOrderByField,
            items: [
                { id: KpiFieldEnum.Indicator, text: 'Indicator' },
                { id: KpiFieldEnum.Target, text: 'Target' },
                { id: KpiFieldEnum.Variation, text: 'Variation' },
                { id: KpiFieldEnum.PercentageVariation, text: '% Variation' },
                { id: KpiFieldEnum.None, text: 'None' },
            ],
            width: 100,
        };

        self.tabDetailOrderDirectionOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.tabDetailOrderByDirection,
            items: [
                { id: Order.ASC, text: 'Asc' },
                { id: Order.DESC, text: 'Desc' },
            ],
            width: 60,
        };

        self.targetFontSizeOptions = {
            value: itemConfig.targetTextConfig.fontSize
        };
        self.titleFontSizeOptions = {
            value: itemConfig.titleTextConfig.fontSize
        };
        
        self.fontStyleButtonGroupOptions = {
            items: self.fontStyleOptions,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: itemConfig.indicatorFontBold() && itemConfig.indicatorFontItalic() ? ['Bold', 'Italic'] :
                itemConfig.indicatorFontBold() ? ['Bold'] : itemConfig.indicatorFontItalic() ? ['Italic'] : [],
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    itemConfig.indicatorFontBold(!itemConfig.indicatorFontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    itemConfig.indicatorFontItalic(!itemConfig.indicatorFontItalic());
                }
            }
        };

        self.fontStyleTargetButtonGroupOptions = {
            items: self.fontStyleOptions,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: itemConfig.targetTextConfig.fontBold() && itemConfig.targetTextConfig.fontItalic() ? ['Bold', 'Italic'] :
                itemConfig.targetTextConfig.fontBold() ? ['Bold'] : itemConfig.targetTextConfig.fontItalic() ? ['Italic'] : [],
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    itemConfig.targetTextConfig.fontBold(!itemConfig.targetTextConfig.fontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    itemConfig.targetTextConfig.fontItalic(!itemConfig.targetTextConfig.fontItalic());
                }
            }
        };

        self.fontStyleTitleButtonGroupOptions = {
            items: self.fontStyleOptions,
            keyExpr: 'style',
            stylingMode: 'outlined',
            selectionMode: 'multiple',
            selectedItemKeys: itemConfig.titleTextConfig.fontBold() && itemConfig.titleTextConfig.fontItalic() ? ['Bold', 'Italic'] :
                itemConfig.titleTextConfig.fontBold() ? ['Bold'] : itemConfig.titleTextConfig.fontItalic() ? ['Italic'] : [],
            onItemClick: function (e) {
                if (e.itemData.style === 'Bold') {
                    itemConfig.titleTextConfig.fontBold(!itemConfig.titleTextConfig.fontBold());
                }
                else if (e.itemData.style === 'Italic') {
                    itemConfig.titleTextConfig.fontItalic(!itemConfig.titleTextConfig.fontItalic());
                }
            }
        };

        //self.tabDetailButtonOptions = {
        //    hint: "Click to open the tab details",
        //    icon: "more",
        //    stylingMode: "text",
        //    visible: itemConfig.tabId,
        //    onClick: function (e) {
        //        let tabId = workbook.workbookConfig.activeTab().id(); // tab.attr("id");
        //        let fieldId = itemConfig.trendAxisField();
        //        let fieldAutoGrouping = itemConfig.trendAxisFieldAutoGrouping();
        //        let filterValue = "";
        //        if (itemConfig.useLastPeriod() && fieldId) {
        //            //filterValue = self.result.trendValues[self.result.trendValues.length - 1].axisValue;
        //        }
        //        else {
        //            fieldId = null; //Set for null so the filters won't get last period when copying filters
        //        }

        //        //let widgetId = self.widgetId ? self.widgetId() : $(e.element).closest("div.dashboardWidget").data("widgetid");

        //        var submitObject = {
        //            fromTabDetail: tabId,
        //            //fromTabDetailWidget: widgetId,
        //            filterValue: filterValue,
        //            filterFieldId: fieldId,
        //            filterFieldAutoGrouping: fieldAutoGrouping,
        //        };

        //        tabView.openTab(itemConfig.tabId(), submitObject);
        //    },
        //};

        itemConfig.comparisonFilter.dateOption.subscribe(function (newValue) {
            if (newValue !== ComparisonDateOptionEnum.Manual) {
                if (!itemConfig.indicatorMetric()) {
                    itemConfig.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);
                }
                else
                    if (itemConfig.targetMetric() === 0 || itemConfig.targetMetric() !== itemConfig.indicatorMetric()) {
                        itemConfig.targetMetric(null);
                    }
            }
            else {
                itemConfig.useLastPeriod(false);
            }
        });

        itemConfig.format.subscribe(function (val) {
            if (val === FieldFormatEnum.Currency) {
                itemConfig.accountingStyle(true);
            }
            else if (val === FieldFormatEnum.Numeric) {
                itemConfig.accountingStyle(false);
            }
        });
    }

    function setBaseTextConfig(textSettings, textConfig: BaseTextConfig) {
        textSettings.alignmentArray = ko.observableArray([textConfig.alignment()]);
        textSettings.alignmentArray.subscribe(function (newValue) {
            textConfig.alignment(newValue[0]);
        });
        textSettings.alignmentOptions = {
            items: [
                {
                    icon: "alignleft",
                    alignment: TextAlignmentEnum.Left,
                    hint: "Align left"
                },
                {
                    icon: "aligncenter",
                    alignment: TextAlignmentEnum.Center,
                    hint: "Center"
                },
                {
                    icon: "alignright",
                    alignment: TextAlignmentEnum.Right,
                    hint: "Align right"
                },
            ],
            keyExpr: "alignment",
            stylingMode: "outlined",
            selectedItemKeys: textSettings.alignmentArray,
            elementAttr: { class: 'dx-textbox-right' },
        };
    }

    function getDistanceOptions(vm) {
        let dataSource = [
            { value: DistanceTypeEnum.Value, text: "Value" },
            { value: DistanceTypeEnum.Percent, text: "Percentage (0%)" },
            { value: DistanceTypeEnum.Percent100, text: "Percentage (100%)" },
            { value: DistanceTypeEnum.ValuePercent, text: "Value and % (0%)" },
            { value: DistanceTypeEnum.ValuePercent100, text: "Value and % (100%)" }
        ];

        return dataSource;
    }
}